// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

/* eslint-disable */

import * as React from "react";
import DashboardBarButton from "./DashboardBarButton";
import { jsx as _jsx } from "react/jsx-runtime";
export const DashboardBarButtonPrecedent = props => {
  const {
    disabled,
    onClick
  } = props;
  const handleClick = React.useCallback(() => {
    onClick?.();
  }, [onClick]);
  return /*#__PURE__*/_jsx(DashboardBarButton, {
    icon: "arrow left",
    label: "Pr\xE9c\xE9dent",
    disabled: disabled,
    onClick: handleClick,
    "data-sentry-element": "DashboardBarButton",
    "data-sentry-component": "DashboardBarButtonPrecedent",
    "data-sentry-source-file": "DashboardBarButtonPrecedent.tsx"
  });
};
export default DashboardBarButtonPrecedent;